var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curr-user"},[_c('span',{staticClass:"fw400"},[_vm._v(_vm._s(_vm.user.email)+" / ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("выйти")])])
}
var staticRenderFns = []

export { render, staticRenderFns }